import { useLocation, useNavigate } from "react-router-dom";
import { CONTACT, NAV_ITEMS } from "@/lib/site";
import { scrollToId } from "@/lib/scroll";

const Footer = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const go = ({ id, to }) => {
    if (to) {
      navigate(to);
      return;
    }
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 400);
    } else {
      scrollToId(id);
    }
  };
  return (
  <footer
    id="contact"
    data-chapter="08"
    data-testid="footer"
    className="border-t border-gold/15 bg-forest-deep text-ivory"
  >
    <div className="mx-auto max-w-[1500px] px-6 py-20 lg:px-14">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <span className="relative inline-block leading-none">
            <span className="font-serif text-6xl font-light text-gold">R</span>
            <span className="absolute -top-1.5 left-[38%] h-1.5 w-1.5 rounded-full bg-accent" aria-hidden="true" />
          </span>
          <p className="mt-6 font-sans text-[11px] font-medium uppercase tracking-[0.32em] text-ivory/80">
            Royal Essence Massage
          </p>
          <p className="mt-1 font-sans text-[9px] uppercase tracking-[0.42em] text-gold/80">
            Massage Beyond Muscles
          </p>
        </div>

        <div className="lg:col-span-4">
          <p className="mb-6 font-sans text-[10px] font-medium uppercase tracking-[0.4em] text-gold">Contact</p>
          <ul className="space-y-4 font-sans text-sm font-light tracking-wide text-ivory/75" data-testid="footer-contact">
            <li className="text-ivory/55">{CONTACT.venue}</li>
            <li>
              <a href={CONTACT.mapUrl} target="_blank" rel="noopener noreferrer" className="transition-colors duration-500 hover:text-gold" data-testid="footer-address">
                {CONTACT.address}
              </a>
            </li>
            <li>
              <a href={`tel:${CONTACT.phone.replace(/[^\d]/g, "")}`} className="transition-colors duration-500 hover:text-gold" data-testid="footer-phone">
                {CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} className="transition-colors duration-500 hover:text-gold" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </li>
          </ul>
          <div className="mt-8 flex gap-6">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="font-sans text-[11px] uppercase tracking-[0.3em] text-ivory/60 transition-colors duration-500 hover:text-gold" data-testid="footer-instagram">
              Instagram
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="font-sans text-[11px] uppercase tracking-[0.3em] text-ivory/60 transition-colors duration-500 hover:text-gold" data-testid="footer-facebook">
              Facebook
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="mb-6 font-sans text-[10px] font-medium uppercase tracking-[0.4em] text-gold">Explore</p>
          <ul className="space-y-4">
            {NAV_ITEMS.map((item) => (
              <li key={item.label}>
                <button
                  onClick={() => go(item)}
                  className="font-sans text-sm font-light tracking-wide text-ivory/75 transition-colors duration-500 hover:text-gold"
                  data-testid={`footer-nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 overflow-hidden rounded-2xl border border-ivory/10" data-testid="footer-map">
        <iframe
          title="Royal Essence Massage — location map"
          src={CONTACT.mapEmbed}
          className="h-64 w-full grayscale-[0.4] sepia-[0.12] lg:h-72"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>

      <div className="mt-20 flex flex-wrap items-center justify-between gap-4 border-t border-ivory/10 pt-8">
        <p className="font-sans text-[10px] uppercase tracking-[0.3em] text-ivory/40" data-testid="footer-copyright">
          © 2026 Royal Essence Massage
        </p>
        <div className="flex flex-wrap items-center gap-x-8 gap-y-2">
          <p className="flex items-center gap-3 font-sans text-[10px] uppercase tracking-[0.3em] text-ivory/40">
            Relief beyond relaxation
            <span className="h-[5px] w-[5px] rounded-full bg-gold" aria-hidden="true" />
          </p>
          <a
            href="https://webempire.ca/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-sans text-[10px] uppercase tracking-[0.3em] text-ivory/40 transition-colors duration-500 hover:text-gold"
            data-testid="footer-credit-webempire"
          >
            Website by <span className="text-ivory/70">WebEmpire</span>
          </a>
        </div>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
